// extracted by mini-css-extract-plugin
export default {"mainContainer":"TermsAndConditions_mainContainer__TigEv","heading":"TermsAndConditions_heading__Yk9Aw"};